function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverview = function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#32bea6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.582,
    height: 0.76,
    x: 0.376,
    y: 0.286,
    rx: 0.049,
    ry: 0.049,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.422.364h.48v.56h-.48z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.422.364v.45l.462-.45z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.674.335a.015.015 0 1 1-.03 0 .015.015 0 0 1 .03 0",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.681.983a.026.026 0 1 1-.052 0 .026.026 0 0 1 .052 0",
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.503.541h.072v.087H.503z",
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.626.492h.072v.136H.626z",
    style: {
      fill: "#17b198"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.749.437h.072v.191H.749z",
    style: {
      fill: "#059bbf"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.569,
    cy: 0.767,
    r: 0.098,
    style: {
      fill: "#facb1b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.726,
    cy: 0.707,
    r: 0.017,
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.76.7h.086v.014H.76z",
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.726,
    cy: 0.756,
    r: 0.017,
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.76.749h.086v.014H.76z",
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.726,
    cy: 0.806,
    r: 0.017,
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.76.799h.086v.014H.76z",
    style: {
      fill: "#cfd3d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.564.766.475.798a.099.099 0 0 0 .171.03z",
    style: {
      fill: "#4ac3af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.612.678.564.766l.047.09a.099.099 0 0 0 0-.178",
    style: {
      fill: "#21b2d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.569.668H.564v.098L.656.72A.1.1 0 0 0 .569.668",
    style: {
      fill: "#fa5655"
    }
  }));
};
export default SvgOverview;